import * as Bowser from 'bowser';

/**
 * Returns the name of the user's operating system.
 */
export function getOSName(): string {
	const _bowser = (Bowser as any).default ?? Bowser; // since bowser is a commonjs module
	const bowser = _bowser.getParser(window.navigator.userAgent);
	return bowser.getOSName();
}

/**
 * Opens the user's default email client with a new message to the specified email(s).
 * @param emails A single email or an array of emails.
 */
export function sendEmail(emails: string | string[]) {
	const emailList = Array.isArray(emails) ? emails.join(',') : emails;
	window.open(`mailto:${encodeURIComponent(emailList)}`);
}

/**
 * Opens the user's default SMS app with a new message to the specified phone number(s).
 * @param phones A single phone number or an array of phone numbers.
 * @param os Optional. The user's operating system ('ios', 'macos', etc.).
 */
export function sendText(phones: string | string[]) {
	const phoneList = Array.isArray(phones) ? phones.join(',') : phones;
	if (getOSName() === 'ios' || getOSName() === 'macos') {
		window.open(`sms:open?addresses=(${encodeURIComponent(phoneList)})`);
	} else {
		window.open(`sms:${encodeURIComponent(phoneList)}`);
	}
}


/**
 * Opens the user's default phone app with a new call to the specified phone number.
 * Only a single phone number is allowed.
 * @param phone A single phone number.
 */
export function openPhone(phone: string) {
	window.open(`tel:${encodeURIComponent(phone)}`);
}